/**
 * `thrivestate.projects.name` ships in two shapes:
 *   - Geniemap-imported: clean project title, e.g. `Mercedes-Benz Places`
 *   - Bot-imported: developer prefix + quoted title, e.g. `LIV "LIV Waterside"`,
 *     `DANUBE "Eleganz"`, `DEYAAR DEVELOPMENT "ATRIA SA"`
 *
 * The bot writes the second form even when the project has a `geniemap_id`, so
 * we can't gate on that. For slug generation we want the inner title only —
 * that's what produces clean URLs like `/projects/danube/eleganz` instead of
 * `/projects/danube/danube-eleganz`. This helper extracts the quoted portion
 * when the bot pattern is present; returns the original name otherwise.
 */

const BOT_NAME_RE = /^[^"]+"(.+)"\s*$/;

export const extractProjectTitle = (rawName: string | null | undefined): string => {
  if (!rawName) return '';
  const trimmed = rawName.trim();
  const m = trimmed.match(BOT_NAME_RE);
  if (m && m[1]) return m[1].trim();
  return trimmed;
};
